// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2rRm3","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2Bq9i","obliqueLine":"membershipbadge_obliqueLine__1o8jV"};